﻿ITVenture.Tools.Popup = {
    dialogs: {},
    initialize: function (name) {
        if (typeof ITVenture.Tools.Popup.dialogs[name] === 'undefined' || ITVenture.Tools.Popup.dialogs[name] === null) {
            var obj =
            {
                refObj: null,
                acceptCallbacks: [],
                showCallbacks: [],
                cancelCallbacks: [],
                closedCallbacks: [],
                window: $("#" + name)
            };
            obj = ITVenture.Tools.Popup.EnrichWindow(obj);

            ITVenture.Tools.Popup.dialogs[name] = obj;
        }

        return ITVenture.Tools.Popup.dialogs[name];
    },
    FindDialog: function (element) {
        return $(element).closest(".itv-dialog");
    },
    Open: function (name, refObj, success, cancel) {
        ITVenture.Tools.Popup.dialogs[name].Open(refObj, success, cancel);
    },
    OpenAsync: function (name, refObj) {
        var prom = new Promise(function (resolve, reject) {
            ITVenture.Tools.Popup.Open(name,
                refObj,
                function (window, dialog, ro, args) {
                    resolve({
                        accepted: true,
                        window: window,
                        dialog: dialog,
                        refObj: ro,
                        customArg: args
                    });
                },
                function (window, dialog, ro) {
                    resolve({
                        accepted: false,
                        window: window,
                        dialog: dialog,
                        refObj: ro,
                        customArg: []
                    });
                });
        });

        return prom;

    },
    Close: function (name) {
        ITVenture.Tools.Popup.dialogs[name].Close.apply(this, Array.prototype.slice.call(arguments, 1));
    },
    Accept: function (name) {
        ITVenture.Tools.Popup.dialogs[name].Accept.apply(this, Array.prototype.slice.call(arguments, 1));
    },
    EnrichWindow: function (obj, windowRef) {
        var tmo = {
            refObj: null,
            acceptCallbacks: [],
            showCallbacks: [],
            cancelCallbacks: [],
            closedCallbacks: [],
            activatedCallbacks: [],
            pressedEnterCallbacks: [],
            handleReturn: false
        };
        if (typeof (windowRef) === "undefined") {
            windowRef = "window";
        }
        var windowObj = obj[windowRef];
        obj = $.extend(true, tmo, obj);
        obj.dialog = function () { return windowObj.data("kendoWindow"); };
        windowObj.data("itvDialog", obj);
        windowObj.addClass("itv-dialog");
        var dg = obj.dialog();
        dg.wrapper.on("keydown",
            function (event) {
                if (event.key === "Enter" && (obj.handleReturn || obj.refObj !== null && typeof (obj.refObj) === "object" && typeof(obj.refObj.handleReturn) === "boolean" && obj.refObj.handleReturn && typeof (obj.refObj.PressedEnter) === "function")) {

                    if (obj.handleReturn) {
                        obj.PressedEnter(event);
                    }
                    else {
                        obj.refObj.PressedEnter(event);
                    }
                }
            });
        dg.bind("close",
            function () {
                try {
                    var i;
                    if (!obj.accepted) {
                        for (i = 0; i < obj.cancelCallbacks.length; i++) {
                            obj.cancelCallbacks[i](obj.window, obj.dialog(), obj.refObj);
                        }
                    }

                    for (i = 0; i < obj.closedCallbacks.length; i++) {
                        obj.closedCallbacks[i](obj.window, obj.dialog(), obj.refObj);
                    }
                } catch (x) {
                    console.log(x);
                }
                obj.dialog().restore();
                obj.refObj = null;
                $(document).scrollTop(obj.scrollTop);
            });
        dg.bind("activate",
            function () {
                for (var i = 0; i < obj.activatedCallbacks.length; i++) {
                    obj.activatedCallbacks[i](obj.window, obj.dialog(), obj.refObj);
                }

            });
        obj.accepted = false;
        obj.Close = function (accepted) {
            obj.accepted = accepted;
            obj.dialog().close();
        };

        obj.Accept = function () {
            var ok = true;
            for (var i = 0; i < obj.acceptCallbacks.length; i++) {
                var tmp = obj.acceptCallbacks[i](obj.window, obj.dialog(), obj.refObj, arguments);
                if (typeof tmp === "boolean") {
                    ok &= tmp;
                }
            }

            if (ok) {
                var arr = Array.prototype.slice.call(arguments, 0);
                arr.unshift(true);
                obj.Close.apply(this, arr);
            }
        };

        obj.Open = function (refObj, success, cancel) {
            if (typeof (success) === "function") {
                obj.onAccept(success);
                if (typeof (cancel) === "function") {
                    obj.onCancel(cancel);
                }

                obj.closedCallbacks = [
                    function () {
                        obj.acceptCallbacks = [];
                        obj.cancelCallbacks = [];
                        obj.closedCallbacks = [];
                    }
                ];
            }

            obj.refObj = refObj;
            for (var i = 0; i < obj.showCallbacks.length; i++) {
                obj.showCallbacks[i](obj.window, obj.dialog(), obj.refObj);
            }

            obj.scrollTop = $(document).scrollTop();
            obj.dialog().open().center();
        };

        obj.PressedEnter = function (event) {
            for (var i = 0; i < obj.pressedEnterCallbacks.length; i++) {
                obj.pressedEnterCallbacks[i].apply(obj, [event]);
            }
        };

        obj.onAccept = function (method) {
            if (typeof (method) === 'function') {
                obj.acceptCallbacks.push(method);
            }
        };

        obj.onShow = function (method) {
            if (typeof (method) === 'function') {
                obj.showCallbacks.push(method);
            }
        };

        obj.onCancel = function (method) {
            if (typeof (method) === 'function') {
                obj.cancelCallbacks.push(method);
            }
        };

        obj.onClosed = function (method) {
            if (typeof (method) === 'function') {
                obj.closedCallbacks.push(method);
            }
        };

        obj.onActivate = function (method) {
            if (typeof (method) === 'function') {
                obj.activatedCallbacks.push(method);
            }
        }

        obj.onPressedEnter = function (method) {
            if (typeof (method) === 'function') {
                obj.pressedEnterCallbacks.push(method);
            }
        }

        return obj;
    },
    createConfirmPopup: function () {
        var obj = {
            refObj: null,
            acceptCallbacks: [],
            showCallbacks: [],
            cancelCallbacks: [],
            closedCallbacks: [],
            window: $('<div class="k-edit-form-container">' +
                '<div id="AlertMessage" class="span10"></div>' +
                '<div class="k-edit-buttons k-state-default">' +
                '<a class="k-button k-button-lg k-primary k-grid-update" href="#" onclick="ITVenture.Tools.Popup.Accept(\'confirm\')"><span class="fa-regular fa-check" ></span><span class="k-button-text">' + ITVenture.Text.getText("Popup_General_OK", "Ok") + '</span></a>' +
                '<a class="k-button k-button-lg k-grid-cancel" href="#" onclick="ITVenture.Tools.Popup.Close(\'confirm\')"><span class="fa-regular fa-ban" ></span><span class="k-button-text">' + ITVenture.Text.getText("Popup_General_Cancel", "Cancel") + '</span></a>' +
                '</div>' +
                '</div>'),
            handleReturn: true
        };
        obj.window.kendoWindow({
            visible: false,
            title: ITVenture.Text.getText("Popup_Confirm_Title", "Confirmation"),
            minWidth: 400,
            minHeight: 110,
            modal: true,
            scrollable: false,
            /*position: {
                top: "30%",
                left: "30%"
            }*/
        });
        obj = ITVenture.Tools.Popup.EnrichWindow(obj);
        obj.onPressedEnter(function (event) {
            if (!($(event.target).hasClass("k-button"))) {
                event.preventDefault();
                ITVenture.Tools.Popup.Accept("confirm");
            }
        });
        obj.onShow(function (window, dialog, refObj) {
            obj.window.children("[id='AlertMessage']").html(refObj);
        });

        var oldOpen = obj.Open;
        obj.Open = function (refObj, success, cancel) {
            obj.onAccept(success);
            obj.onCancel(cancel);
            obj.closedCallbacks = [
                function () {
                    obj.acceptCallbacks = [];
                    obj.cancelCallbacks = [];
                    obj.closedCallbacks = [];
                }
            ];

            obj.Open.oldOpen(refObj);
        };
        obj.Open.oldOpen = oldOpen;
        return obj;
    },
    createAlertPopup: function () {
        var obj = {
            refObj: null,
            acceptCallbacks: [],
            showCallbacks: [],
            cancelCallbacks: [],
            closedCallbacks: [],
            window: $('<div class="k-edit-form-container d-flex flex-column align-items-fill">' +
                '<div id="AlertMessage"></div>' +
                '<div tag="buttons" class="k-edit-buttons k-state-default mt-auto p-2">' +
                '</div>' +
                '</div>'),
            defaultButton: '<a class="k-button k-button-lg k-primary k-grid-update" href="#" onclick="ITVenture.Tools.Popup.Accept(\'alert\')"><span class="fa-regular fa-check" ></span><span class="k-button-text">' + ITVenture.Text.getText("Popup_General_OK", "Ok") + '</span></a>',
            handleReturn: true
        };
        obj.window.kendoWindow({
            visible: false,
            title: ITVenture.Text.getText("Popup_Alert_Title", "Information"),
            minWidth: 400,
            minHeight: 110,
            modal: true,
            scrollable: false,
            /*position: {
                top: "30%",
                left: "30%"
            }*/
        });
        obj = ITVenture.Tools.Popup.EnrichWindow(obj);
        obj.onShow(function (window, dialog, refObj) {
            //obj.window.children("[id='AlertMessage']").html(refObj);
            if (typeof refObj === "string") {
                obj.window.children("[id='AlertMessage']").html(refObj);
                obj.window.children("[tag='buttons']").html(obj.defaultButton);
            } else {
                obj.window.children("[id='AlertMessage']").html(refObj.Message);
                if (typeof (refObj.Buttons) === "object") {
                    var buttonArea = "";
                    $.each(refObj.Buttons,
                        function (id, item) {
                            buttonArea +=
                                '<a class="k-button k-button-lg ' +
                                (item.Default ? 'k-primary k-grid-update' : '') +
                                '" href="#" onclick="ITVenture.Tools.Popup.' +
                                item.Action +
                                '(\'alert\',\'' +
                                item.ActionArgument +
                                '\')"><span class="' +
                                item.SpanClass +
                                '" ></span><span class="k-button-text">' +
                                item.Text +
                                '</span></a>';
                        });
                    obj.window.children("[tag='buttons']").html(buttonArea);
                }
                else {
                    obj.window.children("[tag='buttons']").html(obj.defaultButton);
                }

                if (typeof (refObj.Title) === "string") {
                    dialog.title(refObj.Title);
                }
            }
        });

        var oldOpen = obj.Open;
        obj.Open = function (refObj, success, cancel) {
            obj.onAccept(success);
            obj.onCancel(cancel);
            obj.closedCallbacks = [
                function () {
                    obj.acceptCallbacks = [];
                    obj.cancelCallbacks = [];
                    obj.closedCallbacks = [];
                }
            ];

            obj.Open.oldOpen(refObj);
        };
        obj.Open.oldOpen = oldOpen;
        obj.onPressedEnter(function (event) {
            if (!($(event.target).hasClass("k-button"))) {
                event.preventDefault();
                ITVenture.Tools.Popup.Accept("alert");
            }
        });

        return obj;
    },
    createInputPopup: function () {
        var obj = {
            refObj: null,
            acceptCallbacks: [],
            showCallbacks: [],
            cancelCallbacks: [],
            closedCallbacks: [],
            wnd: $('<form id="inputDlgForm"><div class="k-edit-form-container d-flex flex-column align-items-fill">' +
                '<div id="AlertMessage"></div>' +
                '<div tag="cip-Content" class="flex-row d-flex"></div>' +
                '<div tag="buttons" class="k-edit-buttons k-state-default mt-auto p-2">' +
                '</div>' +
                '</div></form>'),
            defaultButtons: '<button class="k-button k-button-lg k-primary k-grid-update" type="submit" form="inputDlgForm"><span class="fa-regular fa-check" ></span><span class="k-button-text">' + ITVenture.Text.getText("Popup_General_OK", "Ok") + '</span></button>' +
                '<button class="k-button k-button-lg k-grid-cancel" type="button" onclick="ITVenture.Tools.Popup.Close(\'input\')"><span class="fa-regular fa-ban" ></span><span class="k-button-text">' + ITVenture.Text.getText("Popup_General_Cancel", "Cancel") + '</span></button>',
            handleReturn: true
        };
        obj.wnd.kendoWindow({
            visible: false,
            title: ITVenture.Text.getText("Popup_Input_Title", "Input"),
            minWidth: 400,
            minHeight: 190,
            modal: true,
            scrollable: false,
            /*position: {
                top: "30%",
                left: "30%"
            }*/
        });
        obj.form = obj.wnd;
        obj.validator = obj.form.kendoValidator().data("kendoValidator");
        obj.form.on("submit", function (e) {
            e.preventDefault();
            if (obj.validator.validate()) {
                var action = $(e.originalEvent.submitter).attr("submitAction");
                ITVenture.Tools.Popup.Accept('input', action);
            }
        });
        obj = ITVenture.Tools.Popup.EnrichWindow(obj, "wnd");
        obj.window = $(obj.wnd.children()[0]);
        obj.lockButtons = function () {
            obj.window.find("[tag='buttons'] > button, a").addClass("k-state-disabled").attr("disabled", "disabled");
        };
        obj.unlockButtons = function () {
            obj.window.find("[tag='buttons'] > button, a").removeClass("k-state-disabled").attr("disabled", null);
        };
        obj.onPressedEnter(function (event) {
            var dialogInfo = ITVenture.Tools.Popup.FindDialog($(event.target)).data("itvDialog");
            if (dialogInfo.mode.indexOf("WithButtons") === -1) {
                if (!$(event.target).hasClass("k-button")) {
                    event.preventDefault();
                    ITVenture.Tools.Popup.Accept("input");
                }
            }
            else if (typeof dialogInfo.refObj.defaultAction === "string") {
                if (!$(event.target).hasClass("k-button")) {
                    event.preventDefault();
                    ITVenture.Tools.Popup.Accept("input", dialogInfo.refObj.defaultAction);
                }
            }
        });

        obj.onShow(function (window, dialog, refObj) {
            var required = typeof (refObj.required) === "boolean" && refObj.required;
            var inputArea = required ? '<input id="UserInput" class="flex-fill k-input k-textbox" required />' :'<input id="UserInput" class="flex-fill k-input k-textbox" />';
            var buttonArea = obj.defaultButtons;
            var hasDefault = false;
            var defaultValue = "";
            var defaultSize = { width: 400, height: 190 };
            dialog.setOptions(defaultSize);
            obj.mode = "default";
            if (typeof refObj === "string") {
                obj.window.children("[id='AlertMessage']").html(refObj);
            } else {
                obj.window.children("[id='AlertMessage']").html(refObj.Message);
                if (typeof refObj.Controls !== "undefined") {
                    inputArea = refObj.Controls;
                    obj.mode = "custom";
                } else if (typeof refObj.Default !== "undefined") {
                    defaultValue = refObj.Default;
                    hasDefault = true;
                }

                if (typeof refObj.Size === "object") {
                    dialog.setOptions({ width: typeof refObj.Size.width !== "undefined" ? refObj.Size.width : defaultSize.width, height: typeof refObj.Size.height !== "undefined" ? refObj.Size.height : defaultSize.height });
                }
                if (typeof refObj.Buttons !== "undefined") {
                    obj.mode = obj.mode.concat("WithButtons");
                    buttonArea = "";
                    $.each(refObj.Buttons,
                        function (id, item) {
                            buttonArea +=
                                '<button class="k-button k-button-lg ' +
                                (item.Default ? 'k-primary k-grid-update' : '') +
                            (item.Action == "Accept" ? 'type="submit" form="inputDlgForm" submitAction="' + item.ActionArgument : 'type="button" onclick="ITVenture.Tools.Popup.' +
                                item.Action +
                                '(\'input\',\'' + item.ActionArgument + '\')') +
                                '"><span class="' +
                                item.SpanClass +
                                '" ></span><span class="k-button-text">' +
                                item.Text +
                                '</span></button>';
                        });
                }
            }
            obj.window.children("[tag='cip-Content']").html(inputArea);
            obj.window.children("[tag='buttons']").html(buttonArea);
            if (typeof (refObj.buttonsLocked) === "boolean" && refObj.buttonsLocked) {
                obj.lockButtons();
            }

            if (hasDefault) {
                obj.window.find("[id='UserInput']").val(defaultValue);
            }
            //obj.window.children("[id='AlertMessage']").html(refObj);
        });

        var oldOpen = obj.Open;
        obj.Open = function (refObj, success, cancel) {
            obj.onAccept(function (window, dialog, refObj, acceptanceData) {
                if (obj.mode === "default") {
                    success(window, dialog, refObj, window.find("#UserInput").val());
                } else if (obj.mode == "custom") {
                    success(window, dialog, refObj, obj.window.children("[tag='cip-Content']").children());
                }
                else if (obj.mode == "defaultWithButtons") {
                    var dat = {
                        input: window.find("#UserInput").val(),
                        arg: acceptanceData
                    };

                    success(window, dialog, refObj, dat);
                }
                else if (obj.mode == "customWithButtons") {
                    var dat = {
                        cipInput: obj.window.children("[tag='cip-Content']").children(),
                        arg: acceptanceData
                    };

                    success(window, dialog, refObj, dat);
                }
            });
            obj.onCancel(cancel);
            obj.closedCallbacks = [
                function () {
                    obj.acceptCallbacks = [];
                    obj.cancelCallbacks = [];
                    obj.closedCallbacks = [];
                    obj.window.children("[tag='cip-Content']").html("");
                }
            ];

            obj.Open.oldOpen(refObj);
            obj.window.find("#UserInput").focus();
        };
        obj.onActivate(function () {
            obj.window.find("#UserInput").focus();
        });
        obj.Open.oldOpen = oldOpen;
        return obj;
    },
    createPdfPopup: function () {
        var obj = {
            refObj: null,
            acceptCallbacks: [],
            showCallbacks: [],
            cancelCallbacks: [],
            closedCallbacks: [],
            window: $('<div id="viewhoster" width="100%" height="100%"></div>')
        };
        obj.window.kendoWindow({
            visible: false,
            title: ITVenture.Text.getText("Popup_PdfView_Title", "PdfView"),
            minWidth: 1000,
            minHeight: 500,
            width: 1000,
            height: 500,
            modal: true,
            scrollable: false,
            /*position: {
                top: "30%",
                left: "30%"
            }*/
        });
        obj = ITVenture.Tools.Popup.EnrichWindow(obj);
        obj.onShow(function (window, dialog, refObj) {
            var url = refObj;
            var title = null;
            if (typeof (refObj) === "object" && refObj.hasOwnProperty("url")) {
                url = refObj.url;
                if (refObj.hasOwnProperty("title") && typeof (refObj.title) !== "undefined" && refObj.title !== null && refObj.title !== "") {
                    title = refObj.title;
                }
            }
            if (PDFObject) {
                PDFObject.embed(url, obj.window);
            } else {
                obj.window.html(/*'<object data="' + refObj + '" id="viewer" type="application/pdf" width="99%" height="99%">' +*/
                    //"<div>" +
                    '<embed src="' +
                    url +
                    '" id="emViewer" type="application/pdf" width="100%" height= "100%" />' //+
                    /*'</object>'*/);
            }

            if (title !== null) {
                dialog.title(title);
            }
        });

        obj.onClosed(function (win, dialog, refObj) {
            obj.window.empty();
        });

        return obj;
    },
    createGenericPopup: function (rootTagName, windowDef) {
        if (typeof (rootTagName) === "undefined" || rootTagName === null || rootTagName === "") {
            rootTagName = "genericPopupRoot";
        }
        if (typeof (windowDef) !== "object") {
            windowDef = {
                visible: false,
                title: "Generic Popup",
                minWidth: 300,
                minHeight: 100,
                modal: true,
                /*position: {
                    top: "30%",
                    left: "30%"
                }*/
            };
        }

        var markup = '<div id="'.concat(rootTagName).concat('" width="100%" height="100%"></div>');
        var obj = {
            refObj: null,
            acceptCallbacks: [],
            showCallbacks: [],
            cancelCallbacks: [],
            closedCallbacks: [],
            window: $(markup)
        };
        var dlgObj = obj.window.kendoWindow(windowDef);
        var dg = dlgObj.data("kendoWindow");
        obj = ITVenture.Tools.Popup.EnrichWindow(obj);
        var oldOpen = obj.Open;
        obj.Open = function (refObj, success, cancel) {
            obj.onAccept(success);
            obj.onCancel(cancel);
            obj.closedCallbacks = [
                function () {
                    var dlg = obj;
                    $(dlg.window).html("");
                    if (typeof (refObj.dialogClosing) === "function") {
                        refObj.dialogClosing(obj, dg);
                    }
                    obj.acceptCallbacks = [];
                    obj.cancelCallbacks = [];
                    obj.closedCallbacks = [];
                }
            ];
            obj.Open.oldOpen(refObj);
            if (typeof (refObj) === "object") {
                if (typeof (refObj.dialogOpening) === "function") {
                    refObj.dialogOpening(obj, dg);
                }
            }
        };

        obj.Open.oldOpen = oldOpen;

        obj.onShow(function (window, dialog, refObj) {
            var centerAfterLoad = function () {
                dialog.center();
            };
            if (typeof (refObj) === "object") {
                if (typeof (refObj.contentUrl) === "string") {
                    ITVenture.Ajax.ajaxGet(refObj.contentUrl, "text").done(
                        function (data) {
                            $(obj.window).html(data);
                            if (typeof (refObj.contentReady) === "function") {
                                refObj.contentReady(window, dialog);
                            }
                        }, centerAfterLoad).fail(function (err) {
                            if (typeof (refObj.contentFailed) === "function") {
                                refObj.contentFailed(window, dialog, err);
                            }
                        });
                } else if (typeof (refObj.rawContent) === "string") {
                    $(obj.window).html(refObj.rawContent);
                    if (typeof (refObj.contentReady) === "function") {
                        refObj.contentReady(window, dialog);
                    }

                    centerAfterLoad();
                } else {
                    throw "property contentUrl expected!";
                }
            } else {
                throw "object expected!";
            }
        });

        return obj;
    }
}

$(document).ready(function () {
    ITVenture.Tools.Popup.dialogs.alert = ITVenture.Tools.Popup.createAlertPopup();
    ITVenture.Tools.Popup.dialogs.confirm = ITVenture.Tools.Popup.createConfirmPopup();
    ITVenture.Tools.Popup.dialogs.input = ITVenture.Tools.Popup.createInputPopup();
    ITVenture.Tools.Popup.dialogs.pdf = ITVenture.Tools.Popup.createPdfPopup();
    ITVenture.Tools.Popup.dialogs.generic = ITVenture.Tools.Popup.createGenericPopup();
});